<template>
    <rkm-overlay>
        <template v-if="!cboValido">
            <rkm-layout-body title="Acolhimento Saúde Bucal">
                <rkm-alert color="warning">
                    CBO do usuário inválido. A funcionalidade deve ser acessada somente com os seguintes CBOs:
                    <strong>{{ cbosPermitidosDescricao }}</strong>.
                </rkm-alert>
            </rkm-layout-body>
        </template>

        <template v-else-if="[enums.setorTipo.SAUDE_BUCAL].includes(centroCusto.setor.tipoId)">
            <rkm-layout-body title="Acolhimento Saúde Bucal">
                <template v-slot:actions>
                    <rkm-button
                        @click="sair"
                        color="danger"
                    >
                        Sair
                    </rkm-button>

                    <rkm-button
                        @click="save(true)"
                        color="info"
                    >
                        Salvar rascunho
                    </rkm-button>

                    <rkm-button
                        @click="save()"
                        color="primary"
                    >
                        Salvar
                    </rkm-button>
                </template>

                <div
                    class="patient-header"
                    v-if="loaded"
                >
                    <div class="patient-main-card">
                        <div class="patient-top">
                            <div class="patient-content">
                                <div class="patient-identity">
                                    <div class="patient-name-line">
                                        <template v-if="form.paciente.nomeSocial">
                                            <h2 class="patient-name">
                                                {{ form.paciente.nomeSocial }}
                                            </h2>

                                            <span class="badge-social">
                                                Nome social
                                            </span>

                                            <span class="patient-real-name">
                                                {{ form.paciente.nome }}
                                            </span>
                                        </template>

                                        <template v-else>
                                            <h2 class="patient-name">
                                                {{ form.paciente.nome }}
                                            </h2>
                                        </template>

                                        <div class="patient-tags">
                                            <span class="info-chip">
                                                {{ form.paciente.sexoDescricao }}
                                            </span>

                                            <span class="info-chip">
                                                {{ form.paciente.racaCorDescricao }}
                                            </span>

                                            <span
                                                class="info-chip"
                                                v-if="form.paciente.idadeFormatada"
                                            >
                                                {{ form.paciente.idadeFormatada }}
                                            </span>

                                            <span
                                                class="info-chip"
                                                v-if="form.paciente.dataNascimento"
                                            >
                                                DATA NASCIMENTO: {{ form.paciente.dataNascimento }}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                                <div class="patient-grid">
                                    <div class="info-block">
                                        <label>Nome da mãe</label>
                                        <span>
                                            {{ form.paciente.nomeMae || '-' }}
                                        </span>
                                    </div>

                                    <div class="info-block">
                                        <label>Prontuário</label>
                                        <span>
                                            {{ form.paciente.prontuario || '-' }}
                                        </span>
                                    </div>

                                    <div class="info-block">
                                        <label>CPF</label>
                                        <span>
                                            {{ form.paciente.cpf || '-' }}
                                        </span>
                                    </div>

                                    <div class="info-block">
                                        <label>CNS</label>
                                        <span>
                                            {{ form.paciente.cns || '-' }}
                                        </span>
                                    </div>

                                    <div class="info-block">
                                        <label>Telefone</label>
                                        <span>
                                            {{ form.paciente.telefoneNumero || '-' }}
                                        </span>
                                    </div>
                                </div>

                                <div
                                    class="health-flags"
                                    v-if="form.acompanhamentosSaude.length > 0"
                                >
                                    <span class="health-title">
                                        Acompanhamentos:
                                    </span>

                                    <span
                                        v-for="(acompanhamento, index) in form.acompanhamentosSaude"
                                        :key="index"
                                        :class="`health-badge acompanhamento-${acompanhamento.value}`"
                                    >
                                        {{ acompanhamento.text }}
                                    </span>
                                </div>
                            </div>

                            <div
                                class="attendance-card"
                                v-if="additionals"
                            >
                                <div class="attendance-item">
                                    <span>Data atendimento</span>
                                    <strong>{{ additionals.dataAtendimento }}</strong>
                                </div>

                                <div class="attendance-item">
                                    <span>Hora início</span>
                                    <strong>{{ additionals.horaInicioAtendimento }}</strong>
                                </div>

                                <div class="attendance-time">
                                    {{ tempoAtendimento }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <rkm-layout-content>
                    <rkm-form ref="RkmForm">
                    <rkm-tabs>
                        <rkm-tab title="Acolhimento">
                            <rkm-area
                                ref="areaMedicoes"
                                title="Medições"
                                v-if="loaded"
                            >
                                <FormMedicoes
                                    :form="form"
                                    :model="model"
                                />
                            </rkm-area>

                            <template v-if="loaded && (additionals.criaFichaAtencaoBasicaAtendimentoOdontologico || additionals.criaFichaAtencaoBasicaProcedimento)">
                                <rkm-area title="Vigilância em Saúde Bucal">
                                    <FormVigilancia
                                        :form="form"
                                        :model="model"
                                    />
                                </rkm-area>

                                <rkm-area title="Problemas e/ou Condições Avaliados">
                                    <ProblemaCondicao :data="{form, model}" />
                                </rkm-area>

                                <rkm-area
                                    type="fieldset"
                                    title="Procedimentos(Quantidade)"
                                >
                                    <FormProcedimento
                                        :form="form"
                                        :model="model"
                                    />
                                </rkm-area>

                                <rkm-area title="Fornecimento">
                                    <FormFornecimento :model="model" />
                                </rkm-area>
                            </template>

                            <ProcedimentoClinico
                                v-if="loaded"
                                :data="{form, model}"
                            />

                            <rkm-area
                                title="Odontograma"
                                v-if="loaded"
                            >
                                <Odontograma :data="{form, model, readonly: !additionals.podeEditarOdontograma}" />
                            </rkm-area>

                            <template v-if="loaded && (additionals.criaFichaAtencaoBasicaAtendimentoOdontologico || additionals.criaFichaAtencaoBasicaProcedimento)">
                                <rkm-row>
                                    <rkm-col cols="12">
                                        <rkm-form-select
                                            :options="form.equipes"
                                            :validations="{required: true}"
                                            label="Equipe"
                                            show-default-option
                                            text-field="descricao"
                                            v-model="model.equipeId"
                                            value-field="id"
                                        />
                                    </rkm-col>
                                </rkm-row>

                                <rkm-row>
                                    <rkm-col cols="6">
                                        <rkm-form-select
                                            :options="form.turnos"
                                            :validations="{required: true}"
                                            label="Turno"
                                            text-field="nome"
                                            v-model="model.turnoId"
                                            value-field="id"
                                        />
                                    </rkm-col>

                                    <rkm-col cols="6">
                                        <rkm-form-select
                                            :options="form.locaisAtendimento"
                                            :validations="{required: true}"
                                            label="Local de atendimento"
                                            text-field="descricao"
                                            v-model="model.atencaoBasicaLocalAtendimentoId"
                                            value-field="id"
                                        />
                                    </rkm-col>
                                </rkm-row>
                            </template>

                            <rkm-row v-if="loaded">
                                <rkm-col cols="12">
                                    <rkm-form-radio-group
                                        :options="form.atendimentoTipos"
                                        :validations="{required: true}"
                                        label="Tipo de atendimento"
                                        text-field="nome"
                                        v-model="model.atendimentoTipoId"
                                        value-field="id"
                                    />
                                </rkm-col>
                            </rkm-row>

                            <rkm-row v-if="loaded">
                                <rkm-col cols="12">
                                    <rkm-form-radio-group
                                        :options="form.tipoConsulta"
                                        :validations="{required: true}"
                                        label="Tipo de consulta"
                                        text-field="descricao"
                                        v-model="model.tipoConsultaId"
                                        value-field="id"
                                    />
                                </rkm-col>
                            </rkm-row>

                            <Desfecho
                                v-if="loaded"
                                :form="form"
                                :model="model"
                            />
                        </rkm-tab>

                        <rkm-tab
                            title="Histórico"
                            v-if="hasPermissao('show-ambulatorio-historico-atendimento')"
                        >
                            <BoxHistorico
                                v-if="loaded"
                                :data="{form}"
                            />
                        </rkm-tab>
                    </rkm-tabs>
                    </rkm-form>

                    <rkm-area
                        title="Profissional realizando o atendimento"
                        type="fieldset"
                        v-if="loaded"
                    >
                        <rkm-row>
                            <rkm-col>
                                <strong>Profissional: </strong> {{ autenticacao.usuario.cidadao.nome }}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <strong>CBO: </strong> {{ autenticacao.lotacao.ocupacao.codigo }} - {{ autenticacao.lotacao.ocupacao.nome }}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row v-if="autenticacao.usuario.registroTipo && autenticacao.usuario.registroNumero">
                            <rkm-col>
                                <strong>{{ autenticacao.usuario.registroTipoId == enums.tipoRegistro.OUTRO
                                    ? autenticacao.usuario.registroTipoOutro
                                    : autenticacao.usuario.registroTipo.sigla }}: </strong> {{ autenticacao.usuario.registroNumero }}
                            </rkm-col>
                        </rkm-row>

                        <rkm-row>
                            <rkm-col>
                                <strong>Data do atendimento: </strong> {{ additionals.dataAtendimento }} {{ additionals.horaInicioAtendimento }}
                            </rkm-col>
                        </rkm-row>
                    </rkm-area>
                </rkm-layout-content>

                <rkm-fab-area>
                    <rkm-fab>
                        <rkm-fab-item
                            @click="$refs.ModalMedicoes.open()"
                            icon="search"
                            label="Medições"
                        />

                        <rkm-fab-item
                            @click="printCarteiraVacinacao"
                            icon="search"
                            label="Carteira de vacinação"
                        />

                        <rkm-fab-item
                            @click="$refs.ModalResultadoExame.open()"
                            icon="search"
                            label="Resultados de exames"
                        />
                    </rkm-fab>
                </rkm-fab-area>

                <ModalMedicoes
                    v-if="loaded"
                    :data="{
                        additionals: {dataAtual: additionals.dataAtual, paciente: form.paciente},
                        form: form.medicoesHistorico,
                        model: {antropometrias: []},
                    }"
                    ref="ModalMedicoes"
                    readonly
                />

                <ModalResultadoExame
                    v-if="loaded"
                    :data="{form}"
                    ref="ModalResultadoExame"
                />

                <ModalImpressao
                    @closed="closedModalImpressao"
                    ref="ModalImpressao"
                />
            </rkm-layout-body>
        </template>

        <template v-else>
            <rkm-layout-body title="Acolhimento Saúde Bucal">
                <rkm-alert color="warning">
                    É necessário estar logado com um setor do tipo <strong>SAÚDE BUCAL</strong> para poder utilizar a funcionalidade.
                </rkm-alert>
            </rkm-layout-body>
        </template>
    </rkm-overlay>
</template>

<script>
// Components.
import BoxHistorico from '@/components/ambulatorio/atendimento/components/historico/Index'
import Desfecho from '@/components/ambulatorio/acolhimento-saude-bucal/components/desfecho/Index'
import FormFornecimento from '@/components/ambulatorio/acolhimento-saude-bucal/components/fornecimento/Form'
import FormMedicoes from '@/components/ambulatorio/acolhimento-saude-bucal/components/medicoes/Form'
import FormProcedimento from '@/components/ambulatorio/acolhimento-saude-bucal/components/procedimento/Form'
import FormVigilancia from '@/components/ambulatorio/acolhimento-saude-bucal/components/vigilancia/Form'
import ModalImpressao from '@/components/ambulatorio/components/impressao/Modal'
import ModalMedicoes from '@/components/ambulatorio/atendimento/components/medicao/Modal'
import ModalResultadoExame from '@/components/ambulatorio/acolhimento-saude-bucal/components/resultado-exame/Modal'
import Odontograma from '@/components/ambulatorio/acolhimento-saude-bucal/components/odontograma/Index'
import ProblemaCondicao from '@/components/ambulatorio/acolhimento-saude-bucal/components/problema-condicao/Index'
import ProcedimentoClinico from '@/components/ambulatorio/acolhimento-saude-bucal/components/procedimento-clinico/Index'

// Enums.
import ocupacaoCodigo from '@/enums/sigtap/ocupacao'
import setorTipo from '@/enums/cadastro/estabelecimento/setorTipo'
import tipoRegistro from '@/enums/cadastro/usuario/tipoRegistro'

// Mixins.
import {error, file, permissao, repository, stringCase, viewForm} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

const cboPermitido = [
    {codigo: ocupacaoCodigo.TECNICO_EM_SAUDE_BUCAL, nome: 'Técnico em Saúde Bucal'},
    {codigo: ocupacaoCodigo.TECNICO_EM_SAUDE_BUCAL_ESF, nome: 'Técnico em Saúde Bucal da ESF'},
    {codigo: ocupacaoCodigo.AUXILIAR_EM_SAUDE_BUCAL, nome: 'Auxiliar em Saúde Bucal'},
    {codigo: ocupacaoCodigo.AUXILIAR_EM_SAUDE_BUCAL_ESF, nome: 'Auxiliar em Saúde Bucal'},
]

export default {
    components: {
        BoxHistorico,
        Desfecho,
        FormFornecimento,
        FormMedicoes,
        FormProcedimento,
        FormVigilancia,
        ModalImpressao,
        ModalMedicoes,
        ModalResultadoExame,
        Odontograma,
        ProblemaCondicao,
        ProcedimentoClinico,
    },
    computed: {
        ...mapGetters({autenticacao: 'getAutenticacao', centroCusto: 'getCentroCusto', lotacao: 'getLotacao'}),
        cboValido() {
            return cboPermitido.some(cbo => cbo.codigo === this.lotacao.ocupacao.codigo)
        },
        cbosPermitidosDescricao() {
            return cboPermitido.map(cbo => `${cbo.codigo} - ${cbo.nome}`).join(', ')
        },
    },
    created() {
        this.repositories = {
            acolhimentoSaudeBucal: this.getConectaSusRepository('ambulatorio.acolhimentoSaudeBucal'),
            fila: this.getConectaSusRepository('ambulatorio.fila'),
            impressaoImunizacao: this.getConectaSusRepository('impressao.imunizacao'),
        }

        if (this.cboValido && [this.enums.setorTipo.SAUDE_BUCAL].includes(this.centroCusto.setor.tipoId)) {
            this.load()
        }
    },
    beforeDestroy() {
        clearInterval(this.timerInterval)
    },
    data: () => ({
        additionals: null,
        enums: {setorTipo, tipoRegistro},
        form: null,
        loaded: false,
        model: null,
        tempoAtendimento: '00:00:00',
        timerInterval: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        hasPermissao(hash) {
            return this.verificarPermissao(hash)
        },
        load() {
            this.setLoading()

            this.repositories.acolhimentoSaudeBucal.create(this.id)
                .then(response => {
                    this.additionals = response.data.additionals
                    this.form = response.data.form
                    this.model = response.data.model
                    this.$set(this.model, 'desfecho', {finalizado: null, centroCustoEncaminhamentoId: null})

                    this.$nextTick(() => {
                        this.startTimer()

                        this.loaded = true
                    })
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        startTimer() {
            clearInterval(this.timerInterval)

            const dbValue = this.model?.tempoAtendimento

            let baseSeconds = 0

            if (dbValue) {
                if (typeof dbValue === 'number') {
                    baseSeconds = dbValue
                } else {
                    const parts = String(dbValue).split(':').map(Number)
                    if (parts.length === 3) baseSeconds = parts[0] * 3600 + parts[1] * 60 + parts[2]
                    else if (parts.length === 2) baseSeconds = parts[0] * 60 + parts[1]
                }
            }

            const pageLoad = Date.now()

            const tick = () => {
                const elapsed = baseSeconds + Math.floor((Date.now() - pageLoad) / 1000)
                const hh = Math.floor(elapsed / 3600)
                const mm = Math.floor((elapsed % 3600) / 60)
                const ss = elapsed % 60
                this.tempoAtendimento = [hh, mm, ss].map(v => String(v).padStart(2, '0')).join(':')
            }

            tick()
            this.timerInterval = setInterval(tick, 1000)
        },
        save(isRascunho = false) {
            if (isRascunho) {
                this.store(true)

                return
            }

            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    this.store(false)
                })
        },
        store(isRascunho) {
            this.setLoading()

            const params = this.camelObjectKeysToSnakeRecursive(this.model)

            ;['peso', 'altura', 'perimetro_panturrilha', 'circunferencia_abdominal'].forEach(campo => {
                if (params.medicoes[campo]) {
                    params.medicoes[campo] = params.medicoes[campo].replace(',', '.')
                }
            })

            params.is_rascunho = isRascunho
            params.tempo_atendimento = this.tempoAtendimento

            if (params.desfecho.finalizado === 'encaminhar') {
                params.desfecho.finalizado = false
            }

            this.repositories.acolhimentoSaudeBucal.store(this.id, params)
                .then(({data}) => {
                    this.model.procedimentosClinicos = data.procedimentosClinicos

                    if (isRascunho) {
                        this.showSaveNotification()

                        return
                    }

                    this.openModalImpressao(this.additionals.atendimentoId)
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        openModalImpressao(atendimentoId) {
            this.$refs.ModalImpressao.open('atendimento', atendimentoId)
        },
        closedModalImpressao() {
            this.showSaveNotification()

            this.exit(() => this.$router.push({name: 'acolhimento-saude-bucal-index'}), false)
        },
        sair() {
            this.exit(() => {
                this.setLoading()

                this.repositories.fila.sendBack(this.id)
                    .then(() => this.$router.push({name: 'acolhimento-saude-bucal-index'}))
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading())
            })
        },
        printCarteiraVacinacao() {
            this.setLoading()

            this.repositories.impressaoImunizacao.carteiraVacinacao(this.form.paciente.id)
                .then(response => this.openFile(response.data, response.headers['content-type']))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [error, file, permissao, repository, stringCase, viewForm],
    props: {
        id: {type: Number, required: true},
    },
}
</script>

<style scoped>
.acompanhamento-idoso {
    color: #155724;
}

.acompanhamento-gestante {
    color: #ffb6c1;
}

.acompanhamento-hipertenso,
.acompanhamento-diabetico {
    color: #856404;
}

.acompanhamento-saude-mulher {
    color: #b34db2;
}

.acompanhamento-crescimento-desenvolvimento-infantil {
    color: #004085;
}

.patient-header {
    margin-bottom: 15px;
}

.patient-main-card {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    padding: 12px;
    width: 100%;
    box-shadow: 0 1px 6px rgba(0, 0, 0, .05);
}

.patient-top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
}

.patient-content {
    flex: 1;
    min-width: 0;
}

.patient-name-line {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
}

.patient-name {
    font-size: 26px;
    font-weight: 700;
    color: #111827;
    margin: 0;
    line-height: 1.1;
}

.patient-real-name {
    color: #6b7280;
    font-size: 13px;
}

.badge-social {
    background: #ede9fe;
    color: #6d28d9;
    padding: 4px 10px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
}

.patient-tags {
    display: flex;
    gap: 6px;
    margin-top: 2px;
    flex-wrap: wrap;
}

.info-chip {
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
    border-radius: 999px;
    padding: 4px 10px;
    font-size: 11px;
    color: #374151;
    font-weight: 600;
}

.patient-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
    gap: 10px;
    margin-top: 10px;
}

.info-block {
    background: #fff;
    border: 1px solid #e5e7eb;
    border-left: 3px solid #1565c0;
    border-radius: 8px;
    padding: 6px 10px;
    min-height: 52px;

    display: flex;
    flex-direction: column;
    justify-content: center;
}

.info-block label {
    margin: 0;
    font-size: 10px;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: .5px;
    line-height: 1.1;
}

.info-block span {
    margin-top: 2px;
    font-size: 13px;
    font-weight: 600;
    color: #111827;
    line-height: 1.3;
}

.health-flags {
    margin-top: 9px;
    padding-top: 2px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px;
    border-top: 1px solid #e5e7eb;
}

.health-title {
    font-size: 12px;
    color: #6b7280;
    font-weight: 600;
}

.health-badge {
    padding: 5px 10px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 600;
    background: #f3f4f6;
    border: 1px solid #e5e7eb;
}

.attendance-card {
    flex-shrink: 0;
    min-width: 240px;
    background: linear-gradient(
        135deg,
        #1976d2,
        #1565c0
    );
    color: white;
    border-radius: 12px;
    padding: 14px;
    min-height: 125px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-shadow: 0 4px 12px rgba(21, 101, 192, .25);
}

.attendance-item {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    font-size: 12px;
}

.attendance-item span {
    opacity: .85;
}

.attendance-item strong {
    font-weight: 600;
}

.attendance-time {
    margin-top: 6px;
    font-size: 24px;
    font-weight: 700;
    text-align: center;
    letter-spacing: 1px;
}
</style>
